export const getInboundSipTrunkUrl = (locationId: string, agentId: string) =>
  `business/locations/${locationId}/agents/${agentId}/inbound_sip_trunk`;
